export default "__VITE_ASSET__ZOGvauaT__"